module.exports = __webpack_public_path__ + "img/frame-2.46c390f8.svg";